module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/dong-che-fen-logo-9f41a9cfcfcc5d4dedc2abaf2d7f2228.png";